import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
const CustomToggle = React.forwardRef((props, ref) => {
    const { children, onClick } = props;
    function handleClick(e) {
        e.preventDefault();
        onClick(e);
    }
    return (_jsxs("a", Object.assign({ onClick: handleClick, className: "", style: {}, ref: ref }, { children: [_jsx("i", { className: "fa fa-ellipsis-h" }), children] })));
});
const TaskDropdownButton = ({ disabled, menuItems }) => (_jsxs(Dropdown, Object.assign({ pullRight: true, id: "task-dropdown-button" }, { children: [_jsx(CustomToggle, { bsRole: "toggle" }), _jsx(Dropdown.Menu, { children: menuItems.map(menuItem => (_jsx(MenuItem, Object.assign({ onSelect: menuItem.onSelect, disabled: disabled }, { children: _jsxs(_Fragment, { children: [menuItem.icon, " ", menuItem.title] }) }), menuItem.title))) })] })));
export default TaskDropdownButton;
